import { getUser } from "$lib/userstorage/usersotrage"
import { handleAuthenticatedRequest, jsonOrThrow } from "../errores/erroresback"
import { queryClient, cacheRestored } from "$lib/query/queryClient"
import { queryKeys } from "$lib/query/keys"
let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD=="si";
let RUTA_JAVA =bd_local? ruta_local_java:ruta_java;
const RUTA_RODEOS = "herds"
function processHerd(herd) {
    let data_rodeo = {
        id: herd.herdId,
        nombre: herd.name,
        active: herd.isActive,
        cab: herd.establishmentId,
        total: herd.animalCount,
        characteristic: herd.characteristic
    }
    return data_rodeo
}
function processHerds(data, cabid = null) {
    let data_rodeos = []

    for (let i = 0; i < data.length; i++) {
        let fila = data[i]
        data_rodeos.push(processHerd(fila))
        //if (fila.isActive) {
        //    if (cabid) {
        //        if (fila.establishmentId == cabid) {
        //            data_rodeos.push(processHerd(fila))
        //        }
        //    }
        //    else {
        //        data_rodeos.push(processHerd(fila))
        //    }
        //}

    }
    return data_rodeos
}
// Transformacion completa de la respuesta de /herds/all (process + filtro activos).
// Exportada para que el seed del cache (cold-start offline) comparta exactamente
// la misma logica que getAll y nunca diverja.
export function processHerdsResponse(data, cabid = null) {
    return processHerds(data, cabid).filter((r) => r.active);
}
function isRealError(err) {
    return !!err && (err.message === "SESIÓN_EXPIRADA" || err.message === "SIN_PERMISO" || typeof err.status === "number")
}
export async function getAll(cabid = null) {


    let ruta = `${RUTA_JAVA}${RUTA_RODEOS}/all`
    let url = new URL(ruta);
    if (cabid) {
        url.searchParams.append('establishmentId', cabid);
    }
    let user = getUser();
    let token = user.token;
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    try {
        let res_all = await handleAuthenticatedRequest(url.toString(), options)

        let data_all = await jsonOrThrow(res_all, "rodeos.getAll")

        return processHerdsResponse(data_all, cabid)
    } catch (err) {
        if (isRealError(err)) throw err
        await cacheRestored
        const cached = cabid ? queryClient.getQueryData(queryKeys.herds(cabid)) : null
        if (Array.isArray(cached)) return cached
        throw err
    }
}
export async function getHerdlId(id) {
    let ruta = `${RUTA_JAVA}${RUTA_RODEOS}/${id}`
    let user = getUser();
    let token = user.token;
    let options = {
        headers: {

            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await fetch(ruta, options)
    let data_all = await res_all.json()
    let procesada = processHerd(data_all)
    return procesada
}
function postData(data) {
    let data_lot = {
        name: data.nombre,

        establishmentId: data.cab
    }

    return data_lot
}
export async function saveHerd(data) {
    let ruta = `${RUTA_JAVA}${RUTA_RODEOS}`
    let data_lot = postData(data)
    let user = getUser();
    let token = user.token;

    let res_save = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(data_lot), // data can be `string` or {object}!
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
    let data_save = await res_save.json()
    return data_save
}
export async function editHerd(id, data) {
    let ruta = `${RUTA_JAVA}${RUTA_RODEOS}/${id}`

    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "PUT",
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    let data_post = await res_post.json()
    return data_post
}
export async function eliminarHerd(id) {
    let ruta = `${RUTA_JAVA}${RUTA_RODEOS}/delete/${id}`
    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "POST",
            //            body: JSON.stringify({}), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    //let data_post = await res_post.json()
    return {}
}